import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { PictureWithStructuredData } from '@aok/image'

import LinkTitle from '../../atoms/LinkTitle/LinkTitle'
import ClickableTileWrapper from '../../atoms/ClickableTileWrapper/ClickableTileWrapper'
import { ColorScheme } from '../../../utils/defaultTypes'

// Triple Teaser S layout where 'S' refers to the Y004-S layout
const TripleTeaserS = ({ element, settings, className, displayClasses }) => {
  const textClasses = classnames({
    'text-6d767c': settings.colorScheme !== ColorScheme.DARK,
    'text-d8ece8': settings.colorScheme === ColorScheme.DARK,
  })

  const textAbstractClasses = classnames({
    'text-293033': settings.colorScheme !== ColorScheme.DARK,
    'text-ffffff': settings.colorScheme === ColorScheme.DARK,
  })

  return (
    <ClickableTileWrapper url={element.url} className={`tripleTeaser -s flex flex-col gap-24 ${className}`}>
      <div className="relative">
        <PictureWithStructuredData {...element.image} className="w-full" />
      </div>

      <div>
        <span
          className={`
            block mb-8
            text-16 leading-24
            ${textClasses}
          `}
        >
          {element.subtitle}
        </span>

        <LinkTitle theme={settings.colorScheme} url={element.url} title={element.title} className="block mb-8" />
        {element.abstract && (
          <p
            className={`
              text-16 leading-24
              ${textAbstractClasses}
              ${displayClasses ? displayClasses : ''}
            `}
          >
            {element.abstract}
          </p>
        )}
      </div>
    </ClickableTileWrapper>
  )
}

TripleTeaserS.propTypes = {
  element: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    abstract: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.shape({
      alt: PropTypes.string,
      variants: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          breakpoint: PropTypes.number,
        })
      ),
    }),
  }),
  settings: PropTypes.shape({
    colorScheme: PropTypes.string,
  }),
  className: PropTypes.string,
  displayClasses: PropTypes.string,
}

TripleTeaserS.defaultProps = {
  element: {},
  settings: {
    colorScheme: 'structure',
  },
}

export default TripleTeaserS
